var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { arrow as arrowMiddleWare, offset, flip, safePolygon, shift, autoUpdate, useFloating, useInteractions, useClick, useHover, useFocus, useRole, useDismiss, useMergeRefs, } from '@floating-ui/react';
import cx from 'clsx';
import { tooltipRoles } from './Tooltip.constants';
import { arrowBaseStyles, tooltipBaseStyles } from './Tooltip.css';
import { getArrowStyles } from './Tooltip.utils';
export const FloatingTooltip = (_a) => {
    var { children, className, content, isOpen, placement = 'top', role = tooltipRoles.TOOLTIP, setIsOpen, trigger = 'hover' } = _a, rest = __rest(_a, ["children", "className", "content", "isOpen", "placement", "role", "setIsOpen", "trigger"]);
    const arrowRef = React.useRef(null);
    const { x, y, refs, strategy, context, middlewareData: { arrow }, placement: internalPlacement, } = useFloating({
        onOpenChange: setIsOpen,
        open: isOpen,
        placement,
        strategy: 'fixed',
        middleware: [offset(12), flip(), shift(), arrowMiddleWare({ element: arrowRef })],
        whileElementsMounted: autoUpdate,
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([
        useClick(context, { enabled: trigger === 'click' }),
        useHover(context, { enabled: trigger === 'hover', handleClose: safePolygon() }),
        useFocus(context),
        useRole(context, { role }),
        useDismiss(context),
    ]);
    const ref = useMergeRefs([children.ref, refs.setReference]);
    const arrowStyles = getArrowStyles(arrow, internalPlacement);
    return (_jsxs(_Fragment, { children: [React.cloneElement(children, getReferenceProps(Object.assign({ ref }, children.props))), isOpen && (_jsxs("div", Object.assign({ className: cx(tooltipBaseStyles, className), ref: refs.setFloating, style: {
                    position: strategy,
                    top: y !== null && y !== void 0 ? y : 0,
                    left: x !== null && x !== void 0 ? x : 0,
                } }, rest, getFloatingProps(), { children: [_jsx("div", { className: arrowBaseStyles, ref: arrowRef, style: arrowStyles }), content] })))] }));
};
